import React from 'react';
import { cn } from '../../lib/utils';

// 2026-06-16 모바일/태블릿용 좌측 권한 list + 우측 위젯 list (기존 layout).
//   PC 매트릭스 view 와 분리. lg breakpoint 미만에서만 렌더.

const sensitivityTone = {
  normal: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300',
  caution: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300',
  sensitive: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-300',
  restricted: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/20 dark:text-purple-300',
};

const sensitivityLabel = {
  normal: '일반',
  caution: '주의',
  sensitive: '민감',
  restricted: '제한',
};

export default function SituationWidgetMobileList({
  loading,
  widgets,
  permissions,
  connectionMap,
  selectedPerm,
  selectedCodes,
  onSelectPermission,
  onToggleWidget,
}) {
  const selectedPermission = permissions.find((item) => item.code === selectedPerm);
  return (
    <div className="grid grid-cols-1 gap-4">
      <aside className="rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] p-3 max-h-[60vh] overflow-y-auto">
        <div className="px-2 pb-2 text-xs font-black text-[var(--text-sub)]">업무/기능</div>
        {loading ? (
          <div className="p-3 text-sm text-[var(--text-sub)]">불러오는 중...</div>
        ) : permissions.map((perm) => {
          const count = connectionMap[perm.code]?.length || 0;
          return (
            <button
              key={perm.code}
              type="button"
              onClick={() => onSelectPermission(perm.code)}
              className={cn(
                'w-full rounded-xl px-3 py-2.5 text-left mb-1 border transition-colors',
                selectedPerm === perm.code
                  ? 'border-indigo-300 bg-indigo-50 text-indigo-900 dark:bg-indigo-900/20 dark:text-indigo-100'
                  : 'border-transparent hover:bg-[var(--bg-subtle)] text-[var(--text)]'
              )}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-black">{perm.label}</span>
                <span className="text-[11px] font-bold text-[var(--text-sub)]">{count}</span>
              </div>
              <div className="mt-0.5 text-[10px] text-[var(--text-muted)]">{perm.code}</div>
            </button>
          );
        })}
      </aside>

      <section className="rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] overflow-hidden">
        <div className="px-5 py-4 border-b border-[var(--border)]">
          <h3 className="m-0 text-base font-black text-[var(--text)]">
            {selectedPermission?.label || '업무/기능 선택'}
          </h3>
          <p className="mt-1 text-xs text-[var(--text-sub)]">
            기본 연결은 자유롭게 가능하지만, 민감 위젯은 저장 시 한 번 더 확인합니다.
          </p>
        </div>
        <div className="p-4 grid gap-3">
          {widgets.map((widget) => {
            const checked = selectedCodes.includes(widget.code);
            const sources = Array.isArray(widget.data_sources) ? widget.data_sources : [];
            const recommended = Array.isArray(widget.recommended_perm_codes)
              ? widget.recommended_perm_codes.includes(selectedPerm)
              : false;
            return (
              <label
                key={widget.code}
                className={cn(
                  'rounded-xl border p-4 cursor-pointer bg-[var(--bg)] transition-colors',
                  checked ? 'border-indigo-300 ring-1 ring-indigo-200' : 'border-[var(--border)] hover:bg-[var(--bg-subtle)]'
                )}
              >
                <div className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    className="mt-1"
                    checked={checked}
                    onChange={() => onToggleWidget(widget.code)}
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-black text-[var(--text)]">{widget.name}</span>
                      <span className={cn('text-[10px] font-black px-2 py-0.5 rounded-full border', sensitivityTone[widget.sensitivity] || sensitivityTone.normal)}>
                        {sensitivityLabel[widget.sensitivity] || widget.sensitivity}
                      </span>
                      {recommended && <span className="text-[10px] font-bold text-emerald-600">추천 연결</span>}
                    </div>
                    <p className="mt-1 text-xs text-[var(--text-sub)]">{widget.description}</p>
                    <div className="mt-1 text-[11px] text-[var(--text-muted)]">데이터 출처: {sources.join(' / ') || '-'}</div>
                    {widget.warning_text && <div className="mt-1 text-[11px] text-amber-600 dark:text-amber-300">{widget.warning_text}</div>}
                  </div>
                </div>
              </label>
            );
          })}
        </div>
      </section>
    </div>
  );
}
